import styled, { css } from 'styled-components'

import colors from '../../../_constants/colors'

// Components
import { Notes } from '../../../_constants/styles'
import { S_ControlsButton } from '../../ControlsButton'

export const S_BusinessNote = styled.div`
  ${Notes.noteStyles}

  min-height: ${Notes.height};
  width: 100%;

  .actions-bar {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .created-by {
      color: ${colors.TEXT_DARK};
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 15px;

      .created-at {
        color: ${colors.TEXT_LIGHT};
        font-size: 14px;
        font-weight: normal;
        margin-left: 8px;
      }

      .pinned-on {
        color: ${colors.DEFAULT_SECONDARY};
        display: block;
        font-size: 14px;
        font-weight: normal;
      }
    }

    .actions {
      display: inline-block;
      white-space: nowrap;
      width: 80px;
      ${S_ControlsButton} {
        margin-left: 5px;
        height: 20px;
        width: 20px;
      }
    }
  }

  .note-content {
    font-size: 16px;
    font-weight: normal;
    overflow-wrap: break-word;
    white-space: pre-wrap;

    .note-expand-button {
      cursor: pointer;
      color: ${colors.TEXT_LIGHT};
    }
  }

  ${(props) =>
    props.allowActions &&
    css`
      &:hover {
        border: 0.5px solid ${colors.TITLE_GREY};
      }
    ` &&
    props.hover &&
    css`
      .actions-bar {
        .created-by span {
          color: ${colors.TITLE_GREY};
        }
      }
    `}
`
